import React from 'react'

import '@/components/dashboard/misc/Flow.less'

const Flow = ({ maxium }) => {
    return (
        <div className='flow-panel'>
            <img src='/cesium/en_cesium/img/flow.jpeg' alt='通航风险计算流程' className={maxium ? 'flow-img-maxium' : 'flow-img'} />
        </div>
    )
}

export default Flow